import { render, staticRenderFns } from "./DocumentDisplaySettings.vue?vue&type=template&id=46af4efd&scoped=true"
import script from "./DocumentDisplaySettings.vue?vue&type=script&lang=js"
export * from "./DocumentDisplaySettings.vue?vue&type=script&lang=js"
import style0 from "./DocumentDisplaySettings.vue?vue&type=style&index=0&id=46af4efd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46af4efd",
  null
  
)

export default component.exports